import React from 'react';
import { bool, shape, string } from 'prop-types';

const Manager = ({
  className = 'icon',
  notUseClass = false,
  style = { color: 'currentColor' },
}) => (
  <svg className={notUseClass ? '' : className} style={style} width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M12 15.1577L14 19.6667L12 22L10 19.6667L12 15.1577L10.7357 13H13.3405L12 15.1577Z" fill="currentColor" />
    <path fillRule="evenodd" clipRule="evenodd" d="M12 4C9.79 4 8 5.79 8 8C8 10.21 9.79 12 12 12C14.21 12 16 10.21 16 8C16 5.79 14.21 4 12 4ZM14 8C14 6.9 13.1 6 12 6C10.9 6 10 6.9 10 8C10 9.1 10.9 10 12 10C13.1 10 14 9.1 14 8Z" fill="currentColor" />
    <path d="M14.0764 15.2182C14.0739 15.2177 14.0713 15.2172 14.0688 15.2167L14.9871 13.38C17.4452 13.9495 20 15.1584 20 17V20H16L15.7466 19.934L14.9229 18.012L14.9219 18.0117L14.9198 18.0049L14.9177 18L14.0764 15.2182Z" fill="currentColor" />
    <path d="M9.93139 15.2168L9.9233 15.2184L9.92969 15.2188L9.079 18H9.08238L8.25354 19.934L8.11328 20H4V17C4 15.1584 6.55484 13.9495 9.01296 13.3799L9.93139 15.2168Z" fill="currentColor" />
  </svg>
);

Manager.propTypes = {
  className: string,
  notUseClass: bool,
  style: shape({}),
};

export default Manager;
